import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@mui/material';

import type { TModalsContext } from '@/contexts/ModalsProvider/types';

import { GenericModal } from '@/components/modal/GenericModal';

type TFirstRunSuccessProps = TModalsContext & {
  title: string;
};

export const FirstRunSuccess = ({ close, title }: TFirstRunSuccessProps) => {
  const { t } = useTranslation();

  return (
    <GenericModal
      sx={{
        width: 'min(80%, 480px)',
        padding: 6,
      }}
    >
      <Typography variant="h6" textAlign="center" marginBottom={6}>
        {t(title)}
      </Typography>

      <Typography color="text.secondary" marginBottom={6} whiteSpace="pre-line">
        {t('stationSetup.success.details')}
      </Typography>

      <Button onClick={() => close('firstRun.success')} fullWidth>
        {t('stationSetup.success.submit')}
      </Button>
    </GenericModal>
  );
};
